<div class="trip-detail-popup-right">
  <div class="header">
    <div class="row">
      <div class="col-sm-9">
        <h5>Update Driver Route</h5>
      </div>
      <div class="image-fluid col-sm-3">
        <img
          (click)="close()"
          src="../../../assets/img/icons8-macos-close-60.png"
          class="close-icons"
        />
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
</div>

<form class="admin-forms" [formGroup]="coordinatesForm">
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb">
        <div class="col-md-6">
          <mat-label>From</mat-label>
          <mat-form-field class="example-full-width">
            <input
              type="text"
              formControlName="from_complete_address"
              (change)="onInputPickUpchange()"
              #pickUpLocationSearchField
              matInput
              required
            />
            <!-- <span
              *ngIf="coordinatesForm.controls['to_complete_address'].value"
              class="material-icons close-icon"
              (click)="clearPickField()"
              >close</span
            > -->
            <!-- <span
              class="material-icons close-icon"
              *ngIf="showCloseIconPick"
              (click)="clearPickField()"
              style="border: solid"
              >close</span
            > -->
            <mat-error>Please Select From Location</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <mat-label>To</mat-label>
          <mat-form-field class="example-full-width">
            <input
              type="text"
              formControlName="to_complete_address"
              (change)="onDropChange()"
              #dropLocationSearchField
              matInput
              required
            />
            <!-- <span
              *ngIf="coordinatesForm.controls['to_complete_address'].value"
              class="material-icons close-icon"
              (click)="clearDropField()"
              >close</span
            > -->
            <!-- <span
              class="material-icons close-icon"
              *ngIf="showCloseIconDrop"
              (click)="clearDropField()"
              >close</span
            > -->
            <mat-error>Please Select To Location</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-3">
          <mat-label>Date</mat-label>
          <mat-form-field class="example-full-width">
            <input
              formControlName="pickup_date"
              matInput
              [matDatepicker]="picker"
              [min]="minDate"
              (click)="picker.open()"
              required
              readonly
              [disabled]="true"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error>Please Pick a Date</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Price</mat-label>
          <mat-form-field class="example-full-width">
            <input
              matInput
              type="number"
              readonly
              required
              formControlName="price"
            />
            <mat-error>Please Enter Price</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-3">
          <mat-label>Truck no</mat-label>
          <mat-form-field class="example-full-width">
            <input
              formControlName="truck_number"
              matInput
              type="text"
              value="{{ driverList.truck_details[0]?.truck_number }}"
              readonly
            />
            <mat-error>Please Select Truck no</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb flex flex-column">
        <div class="col-md-6 border border-secondary"></div>
        <div class="col-md-6">
          <div class="Fare">Fare Breakup</div>
        </div>
      </div>
      <div class="tax-details">
        <div class="row mtb">
          <div class="col-md-6 fare-details">
            <div class="fare">Route Fare</div>
            <div class="cost">
              ₹
              <!-- {{ driverList.route_fare }} -->
              <!-- {{ driverList.workorderOtherDetails?.loading_point ?? "0.00" }} -->
              <!-- {{
                driverList.workorderOtherDetails?.loading_point ??
                  driverList.price ??
                  "0.00"
              }} -->

              {{
                driverList?.bidDetails[0]?.trip_status === "pending" ||
                driverList?.bidDetails[0]?.trip_status === "trip_not_booked"
                  ? "0.00"
                  : driverList.workorderOtherDetails?.loading_point ??
                    driverList.price ??
                    "0.00"
              }}
            </div>
          </div>
        </div>
        <div class="row mtb">
          <div class="col-md-6">
            <div class="deduct">Deductions</div>
          </div>
        </div>
        <div class="row mtb" *ngFor="let item of driverTax">
          <div class="col-md-6 fare-details">
            <div class="fare">
              {{ item.tax_name }}
              {{ item.tax_deduction }}
              {{ item.tax_type == "percent" ? "%" : "" }}
            </div>
            <div class="cost">
              <div
                class="card-details-right trip_details"
                *ngIf="item?.tax_type == 'percent'"
              >
                ₹
                <!-- {{ calculatedTax }} /- -->
                <!-- {{
                  (driverList.trip_payment_info[0]?.price_details
                    ?.actual_price *
                    item.tax_deduction) /
                    100 | number : "1.2-2"
                }} -->
                {{
                  ((driverList.trip_payment_info[0]?.price_details
                    ?.actual_price ||
                    driverList.price ||
                    0) *
                    item.tax_deduction) /
                    100 | number : "1.2-2"
                }}
              </div>
              <div
                class="card-details-right trip_details"
                *ngIf="item.tax_type == 'amount'"
              >
                ₹ {{ item.tax_deduction }} /-
              </div>
            </div>
          </div>
        </div>
        <div class="row mtb">
          <div class="col-md-6 border"></div>
        </div>
        <div class="row mtb">
          <div class="col-md-6 fare-details">
            <div class="fare">Total Fare</div>
            <div class="cost">
              <!-- {{ driverList.total_fare }}  -->
              <!-- {{ driverList.workorderOtherDetails?.loading_point ?? "0.00" }} -->
              ₹ {{ getTotalFare() | number : "1.2-2" }}
            </div>
          </div>
        </div>
        <div class="row mtb">
          <div class="col-md-6">
            <div class="deduct">(Route Fare After Deductions)</div>
          </div>
          <div class="col-md-6">
            <div class="btn-sec">
              <button class="btn" type="button" (click)="updateRoute()">
                Update Route
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
